import * as React from "react";
import { BaseComponent } from "../../../../react-core/Html/BaseComponent";
import { PartLoading } from "../../../../react-core/Html/PartLoading";
import { Pager } from "../../../../react-core/Html/Pager";
import { ContentTable, NetworkTypeOptions } from "../Resource/Content";
import { NetworkHistoryPaginatedModel } from "../../../../Wrap/Models/Models/Network/NetworkHistoryPaginatedModel";
import { NetworkHistoryModel } from "../../../../Wrap/Models/Models/Network/NetworkHistoryModel";
import { CommonHelper } from "../../../../react-core/Helpers/CommonHelper";
import { FsaAuthorisationStatusMap } from "../../Company/CompanyWizard/Resource/Content";

interface INetworkHistoryTableProps {
    tableData?: NetworkHistoryPaginatedModel;
    currentPage: number;
    pageSize: number;
    isLoading: boolean;
    handlePageChange: (currentPage) => void;
    onSelectNetwork: (network) => void;
}

interface INetworkHistoryTableState {}

export class NetworkHistoryTable extends BaseComponent<INetworkHistoryTableProps, INetworkHistoryTableState> {
    constructor(props: INetworkHistoryTableProps) {
        super(props);
        this.state = {};
    }

    public render(): JSX.Element {
        const { tableData, isLoading } = this.props;

        return (
            <>
                {isLoading ? this.renderPartLoading() : tableData && this.renderTable(tableData)}
                {tableData && tableData.TotalRows > 0 && this.renderPagination()}
            </>
        );
    }

    private renderPartLoading() {
        return (
            <PartLoading isLoading={true}>
                <div className="table-skeleton"></div>
            </PartLoading>
        );
    }

    private renderPagination() {
        const { currentPage, pageSize, handlePageChange } = this.props;
        const { TotalRows } = this.props.tableData;
        return (
            <div className="row">
                <div className="col-12 col-right">
                    <Pager
                        pager={{
                            CurrentPage: currentPage,
                            ResultsPerPage: pageSize,
                            TotalPages: TotalRows / pageSize,
                            TotalRecords: TotalRows,
                        }}
                        onChange={(recordsPerPage: number, pageIndex: number) => {
                            handlePageChange(pageIndex);
                        }}
                        recordsPerPageOptions={[10, 15, 20]}
                        isShowPerPageOptions={false}
                    />
                </div>
            </div>
        );
    }

    private renderTableRow(data: NetworkHistoryModel): JSX.Element {
        return (
            <tr key={data.NetworkId}>
                <td
                    onClick={() => this.props.onSelectNetwork(data)}
                    style={{ textDecoration: "underline", cursor: "pointer" }}
                >
                    {data.Network}
                </td>
                <td>{data.NetworkName}</td>
                <td>{CommonHelper.getOptionsTxt(data.NetworkType, NetworkTypeOptions)}</td>
                <td>{data.FcaTradingReference}</td>
                <td>{FsaAuthorisationStatusMap[data.FcaTradingStatus]}</td>
                <td>{data.DefaultCompanyName}</td>
                <td>{data.PostCode}</td>
            </tr>
        );
    }

    private renderTable(tabledata: NetworkHistoryPaginatedModel): JSX.Element {
        const data = tabledata.networks;
        if (data.length === 0) {
            return <div id="noDataMsg">{ContentTable.noDataMsg}</div>;
        }

        return (
            <div>
                <table className="data-table">
                    <thead>
                        <tr>
                            {Object.values(ContentTable.networkHistoryHeader).map((ele) => {
                                return <th key={ele}>{ele}</th>;
                            })}
                        </tr>
                    </thead>
                    <tbody className="body-split">
                        {data.map((ele) => {
                            return this.renderTableRow(ele);
                        })}
                    </tbody>
                </table>
            </div>
        );
    }
}
